import React from 'react'
import './Home.css'
import swal from 'sweetalert';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faYoutube,
  faFacebook,
  faTwitter,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";

import pic1 from '../image/pic1.jpeg';
import pic9 from '../image/pic9.jpg';
import pic10 from '../image/pic10.jpg';
import pic11 from '../image/pic11.jpg';
import pic12 from '../image/pic12.jpg';
import pic13 from '../image/pic13.jpg';
import pic14 from '../image/pic14.jpg';
import pic15 from '../image/pic15.jpg';
import pic16 from '../image/pic16.jpg';
import pic17 from '../image/pic17.jpg';
import pic18 from '../image/pic18.jpg';
import pic19 from '../image/pic19.jpg';
import pic20 from '../image/pic20.jpg';
import pic21 from '../image/pic21.jpg';
import pic22 from '../image/pic22.jpg';
import pic23 from '../image/pic23.jpg';
import pic121 from '../image/pic121.jpeg';
import insta from '../image/insta.png';
import fb from '../image/fb.png';
import twitter from '../image/twitter.png';
import { HashRouter, Link } from 'react-router-dom';

const Home = props => {
  return (
    <div className="main_containt1">
      <div className="row">
        <div className="column">
          <img src={pic9} width="300" height="300" />
          {/*<div class="extra">DOWNLOAD</div>*/}
        </div>
        <div className="column">
          <img src={pic10} width="300" height="300" />
          {/*<div class="extra">DOWNLOAD</div>*/}
        </div>
        <div className="column">
          <img src={pic22} width="300" height="300" />
          {/*<div class="extra">DOWNLOAD</div>*/}
        </div>
        <div className="column">
          <img src={pic20} width="300" height="300" />
          {/*<div class="extra">DOWNLOAD</div>*/}
        </div>
        <div className="column">
          <img src={pic21} width="300" height="300" />
          {/*<div class="extra">DOWNLOAD</div>*/}
        </div>
        <div className="column">
          <img src={pic23} width="300" height="300" />
          {/*<div class="extra">DOWNLOAD</div>*/}
        </div>
        <div className="column">
          <img src={pic11} width="300" height="300" />
          {/*<div class="extra">DOWNLOAD</div>*/}
        </div>
        <div className="column">
          <img src={pic12} width="300" height="300" />
          {/*<div class="extra">DOWNLOAD</div>*/}
        </div>
        <div className="column">
          <img src={pic13} width="300" height="300" />
          {/*<div class="extra">DOWNLOAD</div>*/}
        </div>
        <div className="column">
          <img src={pic14} width="300" height="300" />
          {/*<div class="extra">DOWNLOAD</div>*/}
        </div>
        <div className="column">
          <img src={pic15} width="300" height="300" />
          {/*<div class="extra">DOWNLOAD</div>*/}
        </div>
        <div className="column">
          <img src={pic16} width="300" height="300" />
          {/*<div class="extra">DOWNLOAD</div>*/}
        </div>
      </div>
    <div className="cr">
      <div className="circle"></div>
        <div className="rect"></div>
        <img className="imgf" src={pic1} />
        <h4 className="nm">RishiQuote | رشی راج </h4>
        <p>&copy; 2020 - 2021 <a href="/">Privacy Policies</a></p>
        <div className="row2">
          <div className="column2">
            <p className="sh">SHARING</p>
          </div>
          <div className="column2">
            <p className="sh">NETWORKING</p>
          </div>
          <div className="column2">
            <p className="sh">LINKS</p>
          </div>
        </div>
        <div className="row1">
          <div className="column1">
            <a href="https://www.instagram.com/rishiquote">
              <img className="sm" src={insta} />
            </a>
          </div>
          <div className="column1">
            <a href="https://www.facebook.com/rishiquote">
              <img className="sm" src={fb} />
            </a>
          </div>
          <div className="column1">
            <img className="sm" src={twitter} />
          </div>
        </div>
        <div className="ty">
          <p>Gazal</p>
          <p>Shayari</p>
          <p>Poetry</p>
        </div>
      </div>
    </div>

  );
};

export default Home;